<template>
    <Mz-Dialog class="dialog" :title="title" width="3820px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="flx-bs main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <div class="left">
                <table class="mytable">
                    <tr>
                        <th style="width:300px"></th>
                        <th>品牌</th>
                        <th>母品牌</th>
                        <th>所属企业</th>
                        <th>推出时间</th>
                    </tr>
                    <tr v-for="item in data.brands" :key="item.brand">
                        <td class="td1">
                            <span>{{item.sort}}</span>
                            <div class="logobox">
                                <img class="logo" :src="item.logo" @click="showCont(item)"/>
                                <div class="mypopper" v-if="item.show">
                                    <div class="pop_content">
                                        <div v-if="item.content" v-html="item.content"></div>
                                        <div v-else style="text-align:center">暂无数据</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>{{item.brand}}</td>
                        <td>{{item.parentBrand}}</td>
                        <td><a :href="item.url" target="_blank" class="link">{{item.company}}</a></td>
                        <td>{{item.time}}</td>
                    </tr>
                </table>
            </div>
            <!-- <div class="middle">
                <div class="mapTitle">{{title}} 分布图</div>
                <div class="map" id="brandMap"></div>
            </div> -->
            <div class="right">
                <div class="part">
                    <a :href="data.outputData.url" target="_blank" class="title">{{data.outputData.title}}</a>
                    <div class="chart1" id="chart1"></div>
                </div>
                <div class="part">
                    <a :href="data.priceData.url" target="_blank" class="title">{{data.priceData.title}}</a>
                    <div class="chart2" id="chart2"></div>
                </div>
            </div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                loading: false,
                mapData: []
            }
        },
        created() {
            // this.mapData = this.data.brands
            this.data.brands.sort((a, b) => a.sort - b.sort);
            this.data.brands.forEach(item => {
                this.$set(item,'show',false)
                let flag = this.mapData.find(it => it.name === item.name)
                if(!flag){
                    this.mapData.push({
                        name: item.name,
                        data: [item]
                    })
                }else{
                    flag.data.push(item)
                }
            })
        },
        mounted() {
            this.$nextTick(() => {
                // this.echartsMap()
                this.echarts1()
                this.echarts2()
            })
        },
        methods: {
            showCont(val){
                this.data.brands.forEach(it => {
                    if(val.brand==it.brand){
                        it.show = !it.show
                    }else{
                        it.show = false
                    }
                })
            },
            echartsMap(){
                var that = this
                var map = echarts.init(document.getElementById('brandMap'));
                // 设置地图配置
                var option = {
                    grid: {
                    left: 0,   // 左侧距离
                    right: 0,  // 右侧距离
                    top: 0,   // 可选：顶部距离
                    bottom: 0, // 可选：底部距离
                    },
                    tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    borderRadius: 15,
                    textStyle: {
                        color: '#ffffff',
                        fontSize: 36
                    },
                    formatter(params) {
                        const data = params.data;
                        if (!data) {
                            return ``
                        }
                        let result = ''
                        data.data.forEach(it => {
                            result += `
                        <div style='padding: 42px 57px 48px 260px;font-size:36px;position:relative;min-height:270px;float:left'>
                        <span style="display:inline-block;text-align:center;width:180px;height:180pxbackground:#fff;overflow:hidden;position:absolute;top:42px;left:45px">
                            <img style="width:100%;" src="${it.logo}" />
                        </span>
                        <h3 style='font-size:42px;font-weight:700;margin-bottom:63px;line-height:60px'>${it.brand}<span style="margin-left:10px">TOP${it.sort}</span></h3>
                        <p>${it.name}</p>
                        </div>`
                        })
                        return  `<div style='width:${data.data.length*520}px;max-width:2250px;overflow:hidden'>${result}</div>`
                    },
                    },
                    geo: [
                        //第一层投影
                        {
                            left: 15,
                            top: 15,
                            width: '100%',
                            height: '100%',
                            map: 'china',
                            zlevel: -1,
                            roam: false, // 鼠标缩放+平移
                            show: true,
                            selectedMode: false,
                            silent: true, // 禁用鼠标交互
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    areaColor: "#0345A1",
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    // shadowBlur: 10
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            emphasis:{
                                show:false
                            },
                            tooltip:{
                                show:false
                            }
                        }
                    ],
                    series: [
                    {
                        // 上层地图
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        name: '中国地图',
                        type: 'map',
                        mapType: 'china',
                        roam: false,
                        itemStyle: {
                        // areaColor: '#387FE9',
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#387FE9'},
                            {offset: 1, color: '#225FBA'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#42AAFF',
                        },
                        emphasis: {
                        itemStyle: {
                            areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                                {offset: 0, color: '#F9B841'},
                                {offset: 1, color: '#FF6524'}
                            ]),
                            borderWidth: 3,
                            borderColor: '#FFD942',
                        }
                        },
                        label: {
                        normal: {
                            show: true,
                            color: '#ffffff',
                            fontSize: 36
                        },
                        emphasis: {
                            color: '#ffffff',
                            fontSize: 36
                        },
                        },
                        data: that.mapData,
                    }
                    ],
                }
                // 设置配置项
                map.setOption(option);
            },
            echarts1(){
            var chart = echarts.init(document.getElementById('chart1'));
            let dataX = this.data.outputData.data.map(it => it.time)
            let dataY = this.data.outputData.data.map(it => it.value)
            // 清空图表
            chart.clear();
            var option = {
                grid: {
                    left: 0,   // 左侧距离
                    right: 258,  // 右侧距离
                    top: 96,   // 可选：顶部距离
                    bottom: 0, // 可选：底部距离
                    containLabel: true // 确保标签不被裁剪
                },
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        color: '#fff', 
                        fontSize: 36,
                    },
                },
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                        color: '#2A54A2', // 设置 x 轴线的颜色
                        width: 3,
                        }
                    },
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff', // 文字颜色
                        fontSize: 28,   // 字体大小
                        margin: 12,
                        rotate: 45
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 2500,
                    axisLine: { 
                        lineStyle: {
                        color: '#2A54A2',
                        width: 3,
                        }
                    },
                    splitLine: { 
                        lineStyle: {
                        color: '#2A54A2',
                        type: 'dashed',
                        width: 2,
                        }
                    },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#fff', // 文字颜色
                        fontSize: 30,   // 字体大小
                        margin: 36,
                    },
                },
                series: [{
                    data: dataY,
                    type: 'line',
                }]
            };
            chart.setOption(option)
            },
            echarts2(){
            var chart = echarts.init(document.getElementById('chart2'));
            let series = [] 
            let dataX = this.data.priceData.times.map(it => it.time)
            let names = []
            this.data.priceData.data.forEach(it => {
                series.push({
                    type: 'line',
                    symbol: 'none',
                    lineStyle: {width:3},
                    name: it.name,
                    data: it.data.map(it => it.value)
                })
                names.push(it.name)
            })
            // 清空图表
            chart.clear();
            var option = {
                grid: {
                    left: 0,   // 左侧距离
                    right: 258,  // 右侧距离
                    top: 96,   // 可选：顶部距离
                    bottom: 0, // 可选：底部距离
                    containLabel: true // 确保标签不被裁剪
                },
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        color: '#fff', 
                        fontSize: 36,
                    },
                },
                legend: {
                    data: names,
                    orient: "vertical",
                    right: 0,
                    top: 70,
                    textStyle: {
                        fontSize: 36,
                        color: '#fff',
                        padding:[0,10]
                    },
                    icon: 'rect', 
                    itemWidth: 68,
                    itemHeight: 3,
                    itemGap: 27
                },
                color: ['#FFBE0C','#A20CFF','#1CFF0C','#AECDFF','#FF510C','#0C85FF'],
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                        color: '#2A54A2', // 设置 x 轴线的颜色
                        width: 3,
                        }
                    },
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff', // 文字颜色
                        fontSize: 28,   // 字体大小
                        margin: 24,
                        rotate: 45
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 2.6,
                    axisLine: { 
                        lineStyle: {
                        color: '#2A54A2',
                        width: 3,
                        }
                    },
                    splitLine: { 
                        lineStyle: {
                        color: '#2A54A2',
                        type: 'dashed',
                        width: 2,
                        }
                    },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#fff', // 文字颜色
                        fontSize: 30,   // 字体大小
                        margin: 32,
                    },
                },
                series: series
            };
            chart.setOption(option)
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 85px 110px 115px 100px;
    .middle{
        position: relative;
        .mapTitle{
            position: absolute;
            left: 0;
            top: 20px;
            height: 84px;
            line-height: 84px;
            background: linear-gradient(90deg, #2A6ACA 0%, rgba(42, 106, 202, 0) 100%);
            padding: 0 30px;
            font-size: 42px;
            font-weight: 700;
            z-index: 1;
        }
        .map{
            width: 2105px;
            height: 1570px;
        }
    }
    .left{
        width: 1760px;
        max-height: 1800px;
        overflow: auto;
        .mytable{
            th{
                height: 144px;
                text-align: center;
            }
            td{
                text-align: center;
                padding: 30px 40px;
            }
            .td1{
                line-height: 84px;
            }
            .logobox{
                display: inline-block;
                position: relative;
                margin-left: 40px;
                .logo{
                    display: inline-block;
                    vertical-align: top;
                    width: 84px;
                    height: 84px;
                    cursor: pointer;
                }
                .mypopper{
                    border: 3px solid #2C5377;
                    background: #05152de6;
                    padding: 40px;
                    color: #fff;
                    position: absolute;
                    left: 84px;
                    top: -3px;
                    z-index: 1;
                    width: 1200px;
                    .pop_content{
                        font-size: 36px;
                        line-height: 55px;
                        white-space: pre-wrap;
                        text-align: left;
                    }
                }
            }
            .link{
                color: #fff;
            }
            .link:hover{
                color: #fff;
                text-decoration: underline;
            }
        }
    }
    .right{
        width: 1715px;
        padding-top: 60px;
        .chart1{
            width: 100%;
            height: 750px;
        }
        .chart2{
            width: 100%;
            height: 750px;
        }
        .part+.part{
            margin-top: 100px;
        }
        .part{
            .title{
                font-size: 42px;
                font-weight: 700;
                line-height: 42px;
                padding-left: 15px;
                border-left: 15px solid #00FFF2;
                color: #fff;
                cursor: pointer;
            }
            .title:hover{
                text-decoration: underline;
            }
        }
    }
}
</style>